import GivePointsPopup from './GivePointsPopup';
import GivePointsPopupContainer from './GivePointsPopup.container';

export default GivePointsPopupContainer(GivePointsPopup);
